import React from 'react';
import { Dialog } from '@leverege/ui-elements';
import PairingFlow from './PairingFlow';
import { jsx as _jsx } from "react/jsx-runtime";
export default class PairingDesktop extends React.Component {
  render() {
    const {
      show,
      onClose,
      ...rest
    } = this.props;
    return /*#__PURE__*/_jsx(Dialog, {
      variant: "pairing",
      show: show,
      onClose: onClose,
      children: /*#__PURE__*/_jsx(PairingFlow, {
        onClose: onClose,
        ...rest
      })
    });
  }
}